var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01667 6.99167C4.21667 9.35 6.15 11.2833 8.50833 12.4833L10.3417 10.65C10.575 10.4167 10.9 10.35 11.1917 10.4417C12.125 10.75 13.125 10.9167 14.1667 10.9167C14.3877 10.9167 14.5996 11.0045 14.7559 11.1607C14.9122 11.317 15 11.529 15 11.75V14.6667C15 14.8877 14.9122 15.0996 14.7559 15.2559C14.5996 15.4122 14.3877 15.5 14.1667 15.5C10.4094 15.5 6.80609 14.0074 4.14932 11.3507C1.49256 8.69391 0 5.09057 0 1.33333C0 1.11232 0.0877973 0.900358 0.244078 0.744078C0.400358 0.587797 0.61232 0.5 0.833333 0.5H3.75C3.97101 0.5 4.18298 0.587797 4.33926 0.744078C4.49554 0.900358 4.58333 1.11232 4.58333 1.33333C4.58333 2.375 4.75 3.375 5.05833 4.30833C5.15 4.6 5.08333 4.925 4.85 5.15833L3.01667 6.99167Z",
    fill: "url(#paint0_linear_535_95)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_95",
    x1: 0.238957,
    y1: 6.8905,
    x2: 15.0095,
    y2: 6.9283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1063AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#1B7E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B5D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/vector7.bf60fab5a3c66a3393d8012d05c0137b.svg";
export { ForwardRef as ReactComponent };